import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../../lib/auth';
import { toast, Toaster } from 'sonner';
import { Lock } from 'lucide-react';

const AdminLogin = () => {
  const { login } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [loading, setLoading] = useState(false);

  const onSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await login(email, password);
      toast.success('Connexion réussie');
      navigate('/admin');
    } catch (err) {
      const detail = err?.response?.data?.detail;
      toast.error(typeof detail === 'string' ? detail : 'Identifiants invalides');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-[#FFFFFF] text-[#111111] flex items-center justify-center px-6" data-testid="admin-login-page">
      <Toaster />
      <div className="w-full max-w-md">
        <div className="text-center mb-12">
          <Lock className="w-8 h-8 text-[#111111] mx-auto mb-6" strokeWidth={1} />
          <span className="text-xs uppercase tracking-[0.4em] text-[#111111] mb-3 block">Espace privé</span>
          <h1 className="text-4xl font-serif">Administration</h1>
          <p className="text-[#111111]/50 mt-4 text-sm">JBMH Events</p>
        </div>
        <form onSubmit={onSubmit} className="space-y-6 bg-[#FFFFFF] p-10 border border-[#111111]/10">
          <div>
            <label className="text-xs uppercase tracking-[0.3em] text-[#111111] mb-3 block">Email</label>
            <input
              type="email"
              required
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              className="w-full bg-transparent border-b border-[#111111]/30 py-3 focus:outline-none focus:border-[#111111] transition-colors text-[#111111]"
              data-testid="admin-login-email"
            />
          </div>
          <div>
            <label className="text-xs uppercase tracking-[0.3em] text-[#111111] mb-3 block">Mot de passe</label>
            <input
              type="password"
              required
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              className="w-full bg-transparent border-b border-[#111111]/30 py-3 focus:outline-none focus:border-[#111111] transition-colors text-[#111111]"
              data-testid="admin-login-password"
            />
          </div>
          <button
            type="submit"
            disabled={loading}
            data-testid="admin-login-submit"
            className="w-full mt-8 px-8 py-4 border border-[#111111] text-[#111111] text-xs uppercase tracking-[0.3em] hover:bg-[#333333] hover:text-[#111111] transition-all disabled:opacity-50"
          >
            {loading ? 'Connexion...' : 'Se connecter'}
          </button>
        </form>
      </div>
    </div>
  );
};

export default AdminLogin;
